<script>
import { CellGroup, Toast, Dialog } from 'vant'
import RadioGroupField from '@/components/org/RadioGroupField'
import PickerSelector from '@/components/org/PickerSelector'
import IntegerStepperField from '@/components/org/IntegerStepperField'
import BottomToolbar from '@/components/org/BottomToolbar'
import ObjectFunc from '@/tbs/util/ObjectFunc'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-game-stats-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-cell-group': CellGroup,
        'radio-group-field': RadioGroupField,
        'picker-selector': PickerSelector,
        'integer-stepper-field': IntegerStepperField,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            game: {
                gameId: null,
                homeTeamId: null,
                awayTeamId: null,
                homeTeamName: null,
                awayTeamName: null,
                matchGroupId: null,
            },
            playerList: {
                homeTeamPlayers: null,
                awayTeamPlayers: null,
            },
            selectedTeamId: null,
            selectedPlayer: {},
            isEdit: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        teamList() {
            return [ 
                { label: this.game.homeTeamName, value: this.game.homeTeamId },
                { label: this.game.awayTeamName, value: this.game.awayTeamId },
            ]
        },
        team() {
            return this.getTeamId()
        },
        teamPlayerList() {
            // console.log('@teamPlayerList', this.selectedTeamId, this.game.awayTeamId, this.selectedTeamId == this.game.awayTeamId)
            const addNewPlayer = { 
                id: '-1', 
                label: this.locale['add-new-player'], 
                value: '-1'
            }
            if (this.selectedTeamId == this.game.awayTeamId) {
                return this.playerList.awayTeamPlayers ? this.playerList.awayTeamPlayers.concat([addNewPlayer]) : []
            }
            else {
                return this.playerList.homeTeamPlayers ? this.playerList.homeTeamPlayers.concat([addNewPlayer]) : []
            }
        },
        hasSelectedPlayer() {
            return this.selectedPlayer.id ? false : true
        },
        selectedPlayerField() {
            console.log('@selectedPlayerField', this.selectedPlayer.value)
            return this.selectedPlayer.value ? this.selectedPlayer.value : null
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onTeamDataChange(data) {
            console.log('onTeamDataChange', data)
            this.selectedTeamId = data
            this.selectedPlayer = {}
        },
        onTeamPlayerDataChange(data) {
            console.log('onTeamPlayerDataChange', data)
            if (data.value === '-1') {
                // navigate to the create player page
                this.$emit('custom-event', {
                    type: 'navigate',
                    data: {
                        name: 'OrgCreatePlayer',
                        query: ObjectFunc.mergeObject({
                            teamId: this.getTeamId(),
                            from: 'OrgCreateGameStats'
                        }, this.game),
                        isReplace: true
                    }
                })
            }
            else {
                this.selectedPlayer = data
            }
        },
        onGoalCountDataChange(data) {
            console.log('onGoalCountDataChange', data, typeof(data))
            this.selectedPlayer.goalCount = data
        },
        onPenaltyGoalCountDataChange(data) {
            console.log('onPenaltyGoalCountDataChange', data, typeof(data))
            this.selectedPlayer.penaltyGoalCount = data
        },
        onOwnGoalCountDataChange(data) {
            console.log('onOwnGoalCountDataChange', data, typeof(data))
            this.selectedPlayer.ownGoalCount = data
        },
        onAssistCountDataChange(data) {
            console.log('onAssistCountDataChange', data, typeof(data))
            this.selectedPlayer.assistCount = data
        },
        onYellowCardCountDataChange(data) {
            console.log('onYellowCardCountDataChange', data, typeof(data))
            this.selectedPlayer.yellowCardCount = data
        },
        onRedCardCountDataChange(data) {
            console.log('onRedCardCountDataChange', data, typeof(data))
            this.selectedPlayer.redCardCount = data
        },
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.selectedPlayer.id) {
                    Toast(this.locale['game-player-id-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-stats'],
                message: this.locale['delete-stats-confirm-message']
            }).then(() => {
                // on confirm
                // clear all count data
                this.selectedPlayer.goalCount = 0
                this.selectedPlayer.penaltyGoalCount = 0
                this.selectedPlayer.ownGoalCount = 0
                this.selectedPlayer.assistCount = 0
                this.selectedPlayer.yellowCardCount = 0
                this.selectedPlayer.redCardCount = 0
                this.submitData()
            }).catch(() => {
                // on cancel
            })
        },
        validateSubmitRequired() {
             console.log('validateSubmitRequired', this.selectedPlayer.id)
            if (this.selectedPlayer.id) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            console.log('submitData', this.selectedPlayer)
            if (this.validateSubmitRequired()) {
                const player = ObjectFunc.cloneObject(this.selectedPlayer)
                player.teamId = this.getTeamId()
                player.gameId = this.game.gameId
                this.$emit('custom-event', {
                    type: 'submit',
                    data: player
                })
            }
        },
        getTeamId() {
            return this.selectedTeamId || this.game.homeTeamId
        },
    },
}
</script>

<template>
    <div class="game-stats-edit">
        <van-cell-group>
            <radio-group-field
                :label="locale['team']"
                :groupList="teamList"
                :value="team"
                :disabled="isEdit"
                @change-data="onTeamDataChange"
            />
            <picker-selector
                :label="locale['player']"
                :options="teamPlayerList"
                :value="selectedPlayerField"
                :disabled="isEdit"
                @change-data="onTeamPlayerDataChange"
            />
        </van-cell-group>
        <van-cell-group>
            <integer-stepper-field
                :label="locale['goal-count-label']"
                :value="selectedPlayer.goalCount"
                :disabled="hasSelectedPlayer"
                @change-data="onGoalCountDataChange"
            />
            <integer-stepper-field
                :label="locale['penaltygoal-count-label']"
                :value="selectedPlayer.penaltyGoalCount"
                :disabled="hasSelectedPlayer"
                @change-data="onPenaltyGoalCountDataChange"
            />
            <integer-stepper-field
                :label="locale['owngoal-count-label']"
                :value="selectedPlayer.ownGoalCount"
                :disabled="hasSelectedPlayer"
                @change-data="onOwnGoalCountDataChange"
            />
            <integer-stepper-field
                :label="locale['assist-count-label']"
                :value="selectedPlayer.assistCount"
                :disabled="hasSelectedPlayer"
                @change-data="onAssistCountDataChange"
            />
            <integer-stepper-field
                :label="locale['yellowcard-count-label']"
                :value="selectedPlayer.yellowCardCount"
                :max="2"
                :disabled="hasSelectedPlayer"
                @change-data="onYellowCardCountDataChange"
            />
            <integer-stepper-field
                :label="locale['redcard-count-label']"
                :value="selectedPlayer.redCardCount"
                :max="1"
                :disabled="hasSelectedPlayer"
                @change-data="onRedCardCountDataChange"
            />
        </van-cell-group>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>